import React from 'react';
import { useTranslation } from "react-i18next";
import { ENTERPRISE_PORTAL_URL } from "../../../constants";

function CTASection() {
  const { t } = useTranslation("global");
  
  return (
    <section id="cta" className="py-16 bg-gradient-to-r from-blue-600 to-blue-800">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-6">
          {t("home.cta-heading", "Prêt à évaluer la maturité de votre entreprise ?")}
        </h2>
        <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
          {t("home.cta-description", "ISOeVAL vous accompagne dans le chemin de la sécurisation de vos actifs, la maîtrise de la qualité, et votre démarche de responsabilité sociétale. Commencez dès aujourd'hui !")}
        </p>
        
        <div className="bg-white/10 backdrop-blur-sm p-8 rounded-lg max-w-3xl mx-auto mb-10">
          <h3 className="text-white text-xl font-bold mb-4">{t("home.cta-evaluate-title", "Ce que vous pouvez évaluer :")}</h3>
          <div className="grid sm:grid-cols-2 md:grid-cols-2 gap-4 mb-6">
            <div className="bg-white/10 p-4 rounded-lg">
              <h4 className="text-white font-bold">{t("home.1", "SSI")}</h4>
              <p className="text-blue-100 text-sm">{t("home.ssi-full", "Sécurité de l'information")}</p>
            </div>
            <div className="bg-white/10 p-4 rounded-lg">
              <h4 className="text-white font-bold">{t("home.2", "QSE")}</h4>
              <p className="text-blue-100 text-sm">{t("home.qse-full", "Qualité, Sécurité & Environnement")}</p>
            </div>
            <div className="bg-white/10 p-4 rounded-lg">
              <h4 className="text-white font-bold">{t("home.3", "RSE")}</h4>
              <p className="text-blue-100 text-sm">{t("home.rse-full", "Responsabilité Sociétale")}</p>
            </div>
            <div className="bg-white/10 p-4 rounded-lg">
              <h4 className="text-white font-bold">{t("home.rgpd", "RGPD")}</h4>
              <p className="text-blue-100 text-sm">{t("home.rgpd-full", "Protection des Données")}</p>
            </div>
          </div>
        </div>
        
        <div className="flex flex-wrap gap-4 justify-center">
          <a
            href={`${ENTERPRISE_PORTAL_URL}/sign-up`}
            className="bg-white text-blue-600 py-3 px-8 text-base hover:shadow-lg font-text rounded-full font-bold transition-all hover:scale-105"
          >
            {t("home.first-section-free-trial")}
          </a>
          
          <a
            href="demo"
            className="bg-transparent text-white border-2 border-white py-3 px-8 text-base hover:bg-white hover:text-blue-600 font-text rounded-full font-bold transition-all"
          >
            {t("header.demo")}
          </a>
          
          <a
            href="contact"
            className="bg-blue-900/30 text-white py-3 px-8 text-base hover:bg-blue-900/50 font-text rounded-full font-bold transition-all"
          >
            {t("contact.contact")}
          </a>
        </div>
      </div>
    </section>
  );
}

export default CTASection;